import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2fdb4c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-loader" }
const _hoisted_2 = { class: "app-loader__inner" }
const _hoisted_3 = { class: "loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: _normalizeClass(["icon icon-spinner", { 'icon-spinner-white': _ctx.whiteSpinner }]),
          style: _normalizeStyle({ fontSize: _ctx.size + 'px' })
        }, null, 6)
      ])
    ])
  ]))
}